import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import routing from './notify_list_index.routes';
import SaConfigService from '../../../components/api/sa_config/sa_config.service';
import ControllerConfigService from '../../../components/api/controller_config/controller_config.service';

export class NotifyListIndexController {
  /*@ngInject*/
  constructor(SaConfigService, ControllerConfigService) {
    this.saList = [];
    this.SaConfigService = SaConfigService;
    this.ControllerConfigService = ControllerConfigService;
  }

  $onInit() {
    this.SaConfigService.api.index().$promise
      .then(response => {
        this.saList = response;

        return this.ControllerConfigService.api.index().$promise;
    })
    .then(response => {
        let controllerDeviceList = response;

        // 検針用端末に紐付く制御用端末を controlTargets に格納する
        this.saList.forEach(device => {
          let controlTargets = controllerDeviceList.filter(controllerDevice => {
            return controllerDevice.reading_device_id === device.id;
          });
          device.controlTargets = controlTargets;
        });
      });
  }
}

export default angular.module('leptonApp.notifyListIndex', [uiRouter, SaConfigService, ControllerConfigService])
  .config(routing)
  .component('notifyListIndex', {
    template: require('./notify_list_index.html'),
    controller: NotifyListIndexController
  })
  .name;



// WEBPACK FOOTER //
// ./public/dev/app/notify_list/index/notify_list_index.component.js